import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
})
export class UploadComponent {
  @Output() fileSelected = new EventEmitter<File | null>();

  selectedFile: File | null = null;
  errorMessage: string = '';

  readonly MAX_FILE_SIZE = 10 * 1024 * 1024;

  readonly ALLOWED_TYPES: string[] = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  onFileSelected(event: Event): void {
    this.errorMessage = '';

    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this.errorMessage = 'Tipo de arquivo não permitido!';
      input.value = '';
      this.selectedFile = null;
      return;
    }

    if (file.size > this.MAX_FILE_SIZE) {
      this.errorMessage = 'Arquivo excede o tamanho máximo permitido (10MB)!';
      input.value = '';
      this.selectedFile = null;
      return;
    }

    this.selectedFile = file;

    // Envia para o componente pai
    this.fileSelected.emit(file);
  }

  clear(): void {
    this.selectedFile = null;
    this.errorMessage = '';

    // limpa o input file visualmente
    const input = document.getElementById('fileUpload') as HTMLInputElement;
    if (input) {
      input.value = '';
    }

    this.fileSelected.emit(null);
  }

  removeFile(input: HTMLInputElement): void {
    input.value = '';
    this.selectedFile = null;
    this.errorMessage = '';
    this.fileSelected.emit(null);
  }
}
